export const leaderboardCategories = [
  { id: 1, name: 'DEFAULT' },
  { id: 2, name: 'IMPORT' },
];
export const options = [
  { name: 'Active', value: 1 },
  { name: 'Inactive', value: 0 },
];
export const visibility = [
  { id: 1, name: 'DEALERSHIP' },
  { id: 2, name: 'GROUP' },
];
export const leaderboardDurationTypes = [
  { id: 1, name: 'DAILY' },
  { id: 2, name: 'WEEKLY' },
  { id: 3, name: 'MONTHLY' },
  { id: 4, name: 'YEARLY' },
];

export const dealershipSortOptions = [
  { id: 1, name: 'Dealership ID' },
  { id: 2, name: 'Dealership Name' },
];

export const orderByList = [
  { id: 'ASC', name: 'Ascending Order' },
  { id: 'DESC', name: 'Descending Order' },
];

export const bottomSheetMenuList = [{ name: 'Remove' }];

export const labelMap = {
  activity: 'Activity Completed',
  guide: 'Guide Completed',
  capstone: 'Capstone Completed',
  aiRolePlay: 'AI RolePlay Completed',
  story: 'Story Completed',
  consistency: 'Consistency Bonus',
  checkin: 'Checkin Completed',
};
